import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

type PaginationChange = { page: number; limit: number };

@Component({
  selector: 'career-pagination',
  standalone: true,
  imports: [CommonModule, NgIf, NgFor, FormsModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() limit = 5;
  @Input() pageSizeOptions: number[] = [5, 10, 20, 50];

  @Output() paginationChange = new EventEmitter<PaginationChange>();

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }

    this.paginationChange.emit({
      page,
      limit: this.limit,
    });
  }

  onLimitChange(value: number | string): void {
    const nextLimit = Number(value);

    if (
      !Number.isFinite(nextLimit) ||
      nextLimit < 1 ||
      nextLimit === this.limit
    ) {
      return;
    }

    this.paginationChange.emit({ page: 1, limit: nextLimit });
  }
}

